import CommonService from "@/domain/dataTable/commonService/CommonService.js";

export default class LojaService extends CommonService {
    getItem() {
        return [
            {
                id: 'situacao_fiscal',
                name: 'Sitação Fiscal',
                description: 'Consulte automaticamente a situação fiscal da sua empresa.',
                buttonValue: 'Adquirido',
                price: '59,90',
                image: "situacao_fiscal.png",
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=195s',
            },
            {
                id: 'extrato_dctf',
                name: 'Extrato DCTF',
                description: 'Analise o extrato da DCTF sem a necessidade de acessar o site da receita federal',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'extrato_dctf.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=260s',
            },
            {
                id: 'relação_de_darfs_pagos',
                name: 'Relação de Darfs Pagos',
                description: 'Exporte a lista de Darfs pagos sem a necessidade de acessar a receita federal.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'relação_de_darfs_pagos.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=320s',
            },
            {
                id: 'emails_caixa_postal',
                name: 'E-mails Caixa Postal',
                description: 'Recebe os emails enviados pela receita federal direto do Motor Fiscal.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'emails_caixa_postal.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=382s',
            },
            {
                id: 'processos',
                name: 'Processos',
                description: 'Consulte os processos que estão andamento na receita federal.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'processos.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=439s',
            },
            {
                id: 'cnd_federal',
                name: 'CND Federal',
                description: 'Certifique-se de que sua empresas não contem nenhum débito com a receita federal.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'cnd_federal.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=503s',
            },

            {
                id: 'relação_de_nfs',
                name: 'Relação de NFs',
                description: 'Visualize as notas de serviços tomados emitidas contra o seu CNPJ de forma automatica.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'relação_de_nfs.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=579s',
            },
            {
                id: 'guias',
                name: 'Guias',
                description: 'Agende a geração de guias municipais e evite retrabalho.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'guias.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=710s',
            },
            {
                id: 'cnd_municipal',
                name: 'CND Municipal',
                description: 'Verifique se sua empresa possui débitos com a prefeitura de forma automática.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'cnd_municipal.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=800s',
            },
            {
                id: 'iptu',
                name: 'IPTU',
                description: 'Baixe de forma automática todas as guias de IPTU do seu imóvel.',
                buttonValue: 'Teste grátis',
                price: '59,90',
                image: 'iptu.png',
                link: 'https://www.youtube.com/watch?v=mTT5wtD8cj8&t=829s',
            },
        ]
    }

    sendEmail(conta, cnpj, item) {
        console.log('Sending email...');
        console.log(conta);
        console.log(cnpj);
        console.log(item);
    }
}


// WEBPACK FOOTER //
// ./src/domain/loja/LojaService.js